<template>
  <form @submit.prevent="save">
    <v-card style="width: 900px">
      <v-card-title>
        <h4>{{ isNew ? $t('crud.newTitle') : $t('crud.editTitle') }}</h4>
      </v-card-title>

      <v-alert error :value="!!error">{{ error }}</v-alert>

      <v-card-text v-if="refresh">

        <v-layout row wrap v-for="row in rows" :key="JSON.stringify(row)">
          <template v-if="Array.isArray(row)">
            <v-flex
              class="pr-5"
              xs6
              v-for="field in row"
              :key="field"
            >
              <crud-form-field
                :ref="`input_${field}`"
                v-model="value"
                :options="fields[field]"
                :field="field"
              />
            </v-flex>
          </template>
          <template v-else>
            <v-flex class="pr-5">
              <crud-form-field
                :ref="`input_${row}`"
                v-model="value"
                :options="fields[row]"
                :field="row"
              />
            </v-flex>
          </template>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn class="elevation-0" type="submit" success :loading="isBusy"><v-icon dark left>save</v-icon> <span>{{ isNew ? $t('create') : $t('save') }}</span></v-btn>
        <v-spacer />
        <v-btn class="elevation-0" error @click="cancel" :loading="isBusy"><v-icon dark left>clear</v-icon> <span>{{ $t('cancel') }}</span></v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import CrudFormField from './CrudFormField'

export default {
  props: {
    fields: Object,
    formOrder: Array,
    value: Object,
    error: String
  },
  created () {
    // Deep copy, please kill me
    this.previous = JSON.parse(JSON.stringify(this.value))
  },
  methods: {
    save () {
      /*
      if (Object.keys(this.fields).find(field => !!this.fields[field].rules.find(rule => rule.bind(this.value)(this.value[field]) !== true))) {
        return
      }
      */
      if (Object.keys(this.fields).find(field => {
        if (this.$refs[`input_${field}`] && this.$refs[`input_${field}`].length) {
          return !this.$refs[`input_${field}`][0].isValid()
        } else {
          return false
        }
      })) {
        return
      }

      this.isBusy = true
      this.$emit('save', this.value)
    },
    cancel () {
      this.$emit('input', this.previous)
      this.$emit('cancel', this.previous)
    },
    saveFailed () {
      this.isBusy = false
      this.refresh = false
      setTimeout(() => {
        this.refresh = true
      })
    }
  },
  data () {
    return {
      fill: [ 'weekdays' ],
      isBusy: false,
      refresh: true,
      previous: null
    }
  },
  watch: {
    value () {
      this.isBusy = false
    }
  },
  computed: {
    isNew () {
      return !this.value._self
    },
    rows () {
      let keys = Object.keys(this.fields)
        .filter(field => {
          let options = this.fields[field]
          if (!options.editable) return false
          if (options.createOnly && this.value._self) return false
          if (options.requires) {
            if (typeof options.requires === 'object') {
              for (let field in options.requires) {
                let target = options.requires[field]
                if (target === false) {
                  if (this.value[field]) return false
                } else if (target === true) {
                  if (!this.value[field]) return false
                } else {
                  if (this.value[field] !== target) return false
                }
              }
            } else {
              if (options.requiresValue === undefined && !this.value[options.requires]) return false
              if (options.requiresValue !== undefined && this.value[options.requires] !== options.requiresValue) return false
            }
          }

          if (options.createOnly && this.value._self) {
            return false
          }

          return true
        })

      keys.sort((a, b) => {
        if (!this.formOrder) {
          return this.fields[a].formOrder - this.fields[b].formOrder
        } else {
          return this.formOrder.indexOf(a) - this.formOrder.indexOf(b)
        }
      })

      let rows = []
      let row = []
      rows.push(row)

      keys.forEach(item => {
        if (this.fill.indexOf(this.fields[item].type) >= 0 || this.fields[item].fill) {
          rows.push(item)
          row = []
          rows.push(row)
        } else {
          row.push(item)
          if (row.length === 2) {
            row = []
            rows.push(row)
          }
        }
      })

      return rows.filter(row => row.length > 0)
    }
  },
  components: {
    CrudFormField
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CrudForm.vue?58f94cc4